import Waypoint from 'waypoints/lib/noframework.waypoints';
import once from 'lodash/once';
import { trackViewportStateForElement } from 'common/utils/trackViewportStateForElement';

export default function createHowItWorksCarousel(element) {
    let interval;
    let $hiwElement;

    const hiwTotalSteps = 3;
    const currentStepAttr = 'data-hiw-current-step';
    const hiwStepAttr = 'data-hiw-step';

    if (element) {
        $hiwElement = $(element);

        new Waypoint({
            element: element,
            handler: once(() => {
                setupEvents();
            }),
            offset: '100%',
        });
    }

    function setupEvents() {
        const $prevTrigger = $hiwElement.find('[data-hiw-carousel-prev-trigger]');
        const $nextTrigger = $hiwElement.find('[data-hiw-carousel-next-trigger]');
        const $hiwStepElements = $hiwElement.find('[' + hiwStepAttr + ']');

        // go to previous step
        $prevTrigger.click(e => {
            let currentStep = parseInt($hiwElement.attr(currentStepAttr), 10);
            stopAutoTransition();
            transitionStep(currentStep - 1);
        });

        // go to next step
        $nextTrigger.click(e => {
            let currentStep = parseInt($hiwElement.attr(currentStepAttr), 10);
            stopAutoTransition();
            transitionStep(currentStep + 1);
        });

        // go to certain step
        $hiwStepElements.each(function() {
            $(this).click(e => {
                let step = parseInt($(this).attr(hiwStepAttr), 10);
                stopAutoTransition();
                transitionStep(step);
            });
        });

        // Reset step if element leaves viewport
        trackViewportStateForElement(element, handleElementInViewportState, { padding: 200 });

        // auto play
        startAutoTransition();
    }

    function handleElementInViewportState({ direction, type }) {
        if (type === 'leave') {
            stopAutoTransition();
            transitionStep(1);
        } else if (type === 'enter') {
            if (!interval) {
                startAutoTransition();
            }
        }
    }

    function transitionStep(currentStep) {
        if (currentStep >= 1 && currentStep <= hiwTotalSteps) {
            $hiwElement.attr(currentStepAttr, currentStep);
        }
    }

    function transitionToNextStep() {
        let currentStep = parseInt($hiwElement.attr(currentStepAttr), 10);

        if (currentStep === 3) {
            currentStep = 1;
        } else {
            currentStep++;
        }

        transitionStep(currentStep);
    }

    function startAutoTransition() {
        interval = setInterval(transitionToNextStep, 6000);
    }

    function stopAutoTransition() {
        clearInterval(interval);
        interval = null;
    }
}
